// import React from 'react';
import PropTypes from 'prop-types';

// class View extends React.Component {
//     constructor(props) {
//         super(props);
//         this.displayName = 'View';
//     }
//     render() {
//         return (
//         	<UI.Container title=""
//         );
//     }
// }

// export default View;



// WEBPACK FOOTER //
// ./src/browser/components/storms/viewStorm.js